const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Заглушки в словарной форме фразы: в примере на их месте стоит конкретное слово
// (blow your top → blew his top, take sb for granted → took her for granted).
const POSSESSIVE = "(?:my|your|his|her|its|our|their|one's|someone's|somebody's)";
const OBJECT = '(?:me|you|him|her|it|us|them)';
const ANY_WORDS = "[\\w'-]+(?:\\s+[\\w'-]+){0,2}?";
const PLACEHOLDERS: Record<string, string> = {
  my: POSSESSIVE,
  your: POSSESSIVE,
  his: POSSESSIVE,
  her: POSSESSIVE,
  their: POSSESSIVE,
  "one's": POSSESSIVE,
  "someone's": POSSESSIVE,
  "somebody's": POSSESSIVE,
  you: OBJECT,
  yourself: "\\w+sel(?:f|ves)",
  oneself: "\\w+sel(?:f|ves)",
  someone: ANY_WORDS,
  somebody: ANY_WORDS,
  something: ANY_WORDS,
  sb: ANY_WORDS,
  sth: ANY_WORDS,
};

const tailPattern = (token: string) =>
  PLACEHOLDERS[token.toLowerCase()] ?? `${escapeRe(token)}(?:e?s)?`;

/**
 * Где в предложении изучаемое слово или фраза: [начало, конец) или null.
 *
 * Первое слово ищем с любым окончанием (draw → draws, top off → topped off); не нашли —
 * укорачиваем основу, чтобы поймать неправильные формы (draw → drew). У одиночного слова
 * основа не короче двух букв, у фразы — до одной: остаток фразы держит совпадение
 * (take off → took off, run out of → ran out of). Остальные слова фразы — как есть,
 * с множественным -s; местоимения-заглушки подменяются любым подходящим словом.
 */
export function findTarget(sentence: string, word: string): [number, number] | null {
  const [head, ...rest] = word.trim().split(/\s+/).filter(Boolean);
  if (!head) return null;
  const tail = rest.map((token) => `\\s+${tailPattern(token)}`).join('') + (rest.length ? '(?!\\w)' : '');
  const minLength = Math.min(rest.length ? 1 : 2, head.length);
  for (let length = head.length; length >= minLength; length -= 1) {
    const found = new RegExp(`\\b${escapeRe(head.slice(0, length))}\\w*${tail}`, 'i').exec(sentence);
    if (found) return [found.index, found.index + found[0].length];
  }
  return null;
}
